/** recoil persist key  */
export const RECOIL_PERSIST_KEY = "insystem-recoil-persist";

// export const ACCESS_TOKEN = "naval-ship-condition-land-access-token";
// export const REFRESH_TOKEN = "naval-ship-condition-land-refresh-token";
export const ACCESS_TOKEN = "insystem-template-access-token";
export const REFRESH_TOKEN = "insystem-template-refresh-token";
